import BottomSheet from './index';
import { compatiblePluginAlias, mergePlugins } from './plugins';

(function ($) {
  if (!$) throw 'BottomSheetError :: load after than jQuery.';

  $.fn.bottomSheet = function (option = {}) {
    const el = this.get(0);
    if (
      el.dataset['xeBottomSheetInstanceId'] &&
      BottomSheet.instances.has(el.dataset['xeBottomSheetInstanceId'])
    ) {
      return BottomSheet.instances.get(el.dataset['xeBottomSheetInstanceId']);
    }

    if (option.contianer && option.contianer instanceof jQuery) {
      option.contianer = option.contianer.get(0);
    }

    return new BottomSheet(el, option);
  };

  $.bottomSheet = {
    events: {
      init: 'xe_bottomsheet::init',
      open: 'xe_bottomsheet::open',
      openDone: 'xe_bottomsheet::open_done',
      close: 'xe_bottomsheet::close',
      closeDone: 'xe_bottomsheet::close_done',
    },
    option: {
      contianer: 'string|object, body',
      initPos: 'number, 0',
      useCover: 'boolean, true',
      useHandle: 'boolean, true',
      isOpen: 'boolean, false',
      openPos: 'number|boolean=false, false',
      customStyleClass: {
        wrapper: 'array|string|undefiend',
        handle: 'array|string|undefiend',
        cover: 'array|string|undefiend',
        contents: 'array|string|undefiend',
      },
      contentsClickOpen: 'boolean, false',
      closeBlockScroll: 'boolean, false',
      transitionTimeout: 'number, 500',
      bodyScroll: 'boolean, false',
      documentScroll: 'boolean, false',
    },
    defaultOption: {
      initPos: 100,
      useCover: true,
      useHandle: true,
      isOpen: false,
    },
  };

  $.bottomSheet.plugins = BottomSheet.plugins;

  $.bottomSheet.addPlugin = function (plugin) {
    BottomSheet.plugins = mergePlugins(
      BottomSheet.plugins,
      compatiblePluginAlias(plugin)
    );
    
    $.bottomSheet.plugins = BottomSheet.plugins;
  };
})(jQuery);
